import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConsts } from "@shared/app-consts";
import {
  KybVerificationCreateRequest,
  KybVerificationDto,
  PdpCompanyRegistrationCreateRequest,
  PdpCompanyRegistrationDto,
  PdpCompanyRegistrationUpdateRequest,
} from "@shared/e-invoice";
import { BaseService } from "@services/base.service";

@Injectable({
  providedIn: "root",
})
export class EInvoicePdpCompanyRegistrationService extends BaseService {
  private readonly baseUrl = AppConsts.API_SERVICE_URL + "pdp";

  constructor(private http: HttpClient) {
    super();
  }

  get(
    tenantId: string,
    countryCode: string,
    siren: string
  ): Observable<PdpCompanyRegistrationDto> {
    const httpOptions = this.getHttpHeader(false);

    return this.http.get<PdpCompanyRegistrationDto>(
      `${this.baseUrl}/tenant/${tenantId}/company/${countryCode}/${siren}`,
      httpOptions
    );
  }

  create(
    tenantId: string,
    request: PdpCompanyRegistrationCreateRequest
  ): Observable<PdpCompanyRegistrationDto> {
    const httpOptions = this.getHttpHeader(false);

    return this.http.post<PdpCompanyRegistrationDto>(
      `${this.baseUrl}/tenant/${tenantId}/company`,
      request,
      httpOptions
    );
  }

  update(
    tenantId: string,
    countryCode: string,
    siren: string,
    request: PdpCompanyRegistrationUpdateRequest
  ): Observable<PdpCompanyRegistrationDto> {
    const httpOptions = this.getHttpHeader(false);

    return this.http.put<PdpCompanyRegistrationDto>(
      `${this.baseUrl}/tenant/${tenantId}/company/${countryCode}/${siren}`,
      request,
      httpOptions
    );
  }

  delete(tenantId: string, countryCode: string, siren: string): Observable<any> {
    const httpOptions = this.getHttpHeader(false);

    return this.http.delete(
      `${this.baseUrl}/tenant/${tenantId}/company/${countryCode}/${siren}`,
      httpOptions
    );
  }

  getKybHistory(
    tenantId: string,
    cabinetId: number,
    taxId: string
  ): Observable<KybVerificationDto[]> {
    const httpOptions = this.getHttpHeader(false);

    return this.http.get<KybVerificationDto[]>(
      `${this.baseUrl}/tenant/${tenantId}/company/Kyb/${cabinetId}?taxId=${taxId}`,
      httpOptions
    );
  }

  /**
   * @param force à true, autorise le prestataire à ouvrir une nouvelle demande alors que la
   * précédente est encore « en cours » — seule sortie possible quand la session de vérification
   * n'est plus utilisable (lien mort), le prestataire ne régénérant pas de lien.
   */
  requestKyb(
    tenantId: string,
    cabinetId: number,
    taxId: string,
    request: KybVerificationCreateRequest,
    force: boolean = false
  ): Observable<KybVerificationDto> {
    const httpOptions = this.getHttpHeader(false);
    const forceParam = force ? "&force=true" : "";

    return this.http.post<KybVerificationDto>(
      `${this.baseUrl}/tenant/${tenantId}/company/Kyb/${cabinetId}?taxId=${taxId}${forceParam}`,
      request,
      httpOptions
    );
  }
}
